<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveTask()" autocomplete="off">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Destinatários <span class="text-danger">*</span></label>
                <select
                  v-model="task.type_contact"
                  class="custom-select"
                  :class="{ 'is-invalid': submitted && $v.task.type_contact.$error }"
                >
                  <option value="">Selecione...</option>
                  <option value="guests">Convidados</option>
                  <option value="registered">Inscritos</option>
                </select>
                <div v-if="submitted && !$v.task.type_contact.required" class="invalid-feedback">
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Filtrar por</label>
                <select
                  class="custom-select"
                  v-model="task.type_filter"
                  @change="setFilterTask()"
                >
                  <option value="">Todos</option>
                  <option value="group">Grupo</option>
                  <option value="status">Status</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row" v-if="task.type_filter === 'group'">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Grupos</label>
                <multiselect tag-placeholder="Selecione" placeholder="Selecione um ou mais grupos" v-model="task.groups" label="name" track-by="id" :options="groups" :multiple="true"></multiselect>
              </div>
            </div>
          </div>
          <div class="row" v-if="task.type_filter === 'status'">
            <div :class="hasPendenteSelected ? 'col-sm-6' : 'col-sm-12'">
              <div class="form-group">
                <label>Status</label>
                <multiselect tag-placeholder="Selecione" placeholder="Selecione um ou mais status" v-model="task.status" :options="statusSelect" track-by="id" label="name" :multiple="true"></multiselect>
              </div>
            </div>
            <div class="col-sm-6" v-if="hasPendenteSelected">
              <div class="form-group">
                <label>Tipo Pendência (Sub-status)</label>
                <multiselect tag-placeholder="Selecione" placeholder="Selecione um ou mais sub-status" v-model="task.ref_status" :options="refStatusOptions" track-by="id" label="name" :multiple="true"></multiselect>
              </div>
            </div>
          </div>

          <hr>

          <div class="row">
            <div :class="task.target_status == 2 ? 'col-sm-6' : 'col-sm-12'">
              <div class="form-group">
                <label>Novo Status <span class="text-danger">*</span></label>
                <select
                  v-model="task.target_status"
                  class="custom-select"
                  :class="{ 'is-invalid': submitted && $v.task.target_status.$error }"
                  @change="onTargetStatusChange()"
                >
                  <option value="">Selecione...</option>
                  <option v-for="s in statusSelect" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select>
                <div v-if="submitted && !$v.task.target_status.required" class="invalid-feedback">
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6" v-if="task.target_status == 2">
              <div class="form-group">
                <label>Novo Sub-status</label>
                <select
                  v-model="task.target_ref_status"
                  class="custom-select"
                >
                  <option value="">Selecione...</option>
                  <option v-for="(name, id) in refstatusList" :key="id" :value="id">{{ name }}</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Contador -->
          <div class="count-box" v-if="task.type_contact">
            <i class="bx bx-group"></i>
            <span v-if="countLoading"><i class="bx bx-loader-alt bx-spin"></i> Calculando...</span>
            <span v-else-if="participantCount > 0"><strong>{{ participantCount }}</strong> {{ participantCount === 1 ? 'participante' : 'participantes' }} serão afetados</span>
            <span v-else class="text-warning">Nenhum participante encontrado com os filtros selecionados</span>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <b-button variant="primary" @click="saveTask()" :disabled="saving || countLoading || participantCount === 0">
        {{ saving ? 'Executando...' : 'Executar' }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { countParticipants } from './services'

export default {
  components: {
    Loading,
    Multiselect
  },
  data () {
    return {
      title: 'Mudança de Status em Massa',
      loading: true,
      saving: false,
      submitted: false,
      participantCount: 0,
      countLoading: false,
      countTimer: null,
      task: {
        type_contact: '',
        type_filter: '',
        groups: [],
        status: [],
        ref_status: [],
        target_status: '',
        target_ref_status: ''
      },
      modal: false
    }
  },
  validations: {
    task: {
      type_contact: { required },
      target_status: { required }
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settings', ['statusSelect', 'refstatusList']),
    ...mapState('group', ['groups']),
    hasPendenteSelected () {
      return this.task.status && this.task.status.some(s => parseInt(s.id) === 2)
    },
    refStatusOptions () {
      if (!this.refstatusList || typeof this.refstatusList !== 'object') return []
      return Object.entries(this.refstatusList).map(([id, name]) => ({ id: parseInt(id), name }))
    }
  },
  methods: {
    ...mapActions('taskChangeStatus', { postData: 'save' }),
    ...mapActions('settings', { GetStatus: 'GetStatusSelect', GetRefStatus: 'GetRefStatusList' }),
    ...mapActions('group', { getAllGroups: 'getAll' }),
    getGroups () {
      this.getAllGroups({ status: 1, limit: 100, page: 1 }).catch(error => {
        console.log(error)
      })
    },
    setFilterTask () {
      this.task.groups = []
      this.task.status = []
      this.task.ref_status = []
      this.fetchCount()
    },
    onTargetStatusChange () {
      this.task.target_ref_status = ''
    },
    fetchCount () {
      if (this.countTimer) clearTimeout(this.countTimer)
      if (!this.task.type_contact) {
        this.participantCount = 0
        return
      }
      this.countTimer = setTimeout(() => {
        this.countLoading = true
        let payload = {
          type_contact: this.task.type_contact,
          type_filter: this.task.type_filter || '',
          status: this.task.status ? JSON.stringify(this.task.status) : '[]',
          groups: this.task.groups ? JSON.stringify(this.task.groups) : '[]',
          ref_status: this.task.ref_status ? JSON.stringify(this.task.ref_status) : '[]'
        }
        countParticipants(payload).then(res => {
          this.participantCount = res.data.count || 0
          this.countLoading = false
        }).catch(() => {
          this.participantCount = 0
          this.countLoading = false
        })
      }, 400)
    },
    open () {
      this.modal = true
      this.loading = true
      this.getGroups()
      this.GetStatus()
      this.GetRefStatus()
      this.loading = false
    },
    async saveTask () {
      this.submitted = true
      this.$v.task.$touch()
      if (this.$v.task.$invalid) {
        return
      }
      if (this.participantCount === 0) {
        errorMessage('Nenhum participante encontrado com os filtros selecionados.')
        return
      }

      this.saving = true
      this.loading = true

      let payload = {
        type_contact: this.task.type_contact,
        type_filter: this.task.type_filter || '',
        target_status: this.task.target_status,
        target_ref_status: this.task.target_ref_status || '',
        status: this.task.status ? JSON.stringify(this.task.status) : '[]',
        groups: this.task.groups ? JSON.stringify(this.task.groups) : '[]',
        ref_status: this.task.ref_status ? JSON.stringify(this.task.ref_status) : '[]'
      }

      await this.postData(payload).then(() => {
        successMessage('Sucesso: Ação registrada com sucesso, em minutos os status serão atualizados.', 2500)
        this.$v.$reset()
        this.loading = false
        this.saving = false
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
        this.saving = false
      })
    },
    close () {
      this.modal = false
      this.submitted = false
      this.saving = false
      this.participantCount = 0
      this.task = {
        type_contact: '',
        type_filter: '',
        groups: [],
        status: [],
        ref_status: [],
        target_status: '',
        target_ref_status: ''
      }
      this.$v.$reset()
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    },
    'task.type_contact' () {
      this.fetchCount()
    },
    'task.groups' () {
      this.fetchCount()
    },
    'task.status' () {
      this.fetchCount()
    },
    'task.ref_status' () {
      this.fetchCount()
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
  z-index: 1051 !important;
}
.count-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f4f5f7;
  border-radius: 6px;
  font-size: 14px;
  color: #495057;
  margin-top: 4px;
}
.count-box i.bx-group {
  font-size: 18px;
  color: #556ee6;
}
</style>
